module.exports = __webpack_public_path__ + "static/media/undraw_beer_celebration_3wc8.075a777d.svg";